export type FfsLevel = '1' | '2'

export enum FfsPart {
  PART_4 = 'part-4',
  PART_5 = 'part-5',
}

export enum FfsResultType {
  Pass = 'pass',
  Derate = 'derate',
  Fail = 'fail',
  Pending = 'pending',
  Skipped = 'skipped',
}
